export default __webpack_public_path__ + "static/media/layout3.01456985.jpg";